var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { useTable, useSortBy, useExpanded, useRowState } from 'react-table';
import usePrevious from '@ally/use-previous';
import { useMediaSize } from '../tools/utils';
import LgUpTable from './LgUpTable';
import TableCardList from './TableCardList';
import { getRowToExpand, getSortBy, handleDrawerCloses } from './utils';
var drawerSet = new WeakSet();
var getSubRows = function (row) {
    if (drawerSet.has(row))
        return [];
    var drawer = __assign({}, row);
    drawerSet.add(drawer);
    return [drawer];
};
var TableRefForwarding = function (_a, ref) {
    var data = _a.data, columns = _a.columns, suppressMdDownLayout = _a.suppressMdDownLayout, withFooter = _a.withFooter, multipleDrawersOpen = _a.multipleDrawersOpen, drawer = _a.drawer, onDrawerClose = _a.onDrawerClose, withRowHeadings = _a.withRowHeadings, rowClickHandler = _a.rowClickHandler, selectRow = _a.selectRow, fullWidth = _a.fullWidth, _b = _a.showFromMdDown, showFromMdDown = _b === void 0 ? [] : _b, mdDownHeaderDetail = _a.mdDownHeaderDetail, _c = _a.mdDownDrawerName, mdDownDrawerName = _c === void 0 ? 'Details' : _c, mdDownColumnFullWidth = _a.mdDownColumnFullWidth, _d = _a.autoResetSortBy, autoResetSortBy = _d === void 0 ? true : _d, _e = _a.autoResetExpanded, autoResetExpanded = _e === void 0 ? true : _e, sharedProps = __rest(_a, ["data", "columns", "suppressMdDownLayout", "withFooter", "multipleDrawersOpen", "drawer", "onDrawerClose", "withRowHeadings", "rowClickHandler", "selectRow", "fullWidth", "showFromMdDown", "mdDownHeaderDetail", "mdDownDrawerName", "mdDownColumnFullWidth", "autoResetSortBy", "autoResetExpanded"]);
    var isLgUp = useMediaSize('LgUp');
    var tableInstance = useTable(__assign({ columns: React.useMemo(function () { return columns; }, [columns]), data: React.useMemo(function () { return data; }, [data]), initialState: React.useMemo(function () { return (__assign({}, getSortBy(columns))); }, [columns]), disableMultiSort: true, disableSortRemove: true, autoResetSortBy: autoResetSortBy, autoResetExpanded: autoResetExpanded }, (drawer && { getSubRows: getSubRows })), useSortBy, useExpanded, useRowState);
    var expanded = tableInstance.state.expanded, toggleAllRowsExpanded = tableInstance.toggleAllRowsExpanded, toggleRowExpanded = tableInstance.toggleRowExpanded, preExpandedRows = tableInstance.preExpandedRows;
    var prevExpanded = usePrevious(expanded);
    useEffect(function () {
        handleDrawerCloses({
            drawer: drawer,
            onDrawerClose: onDrawerClose,
            expanded: expanded,
            prevExpanded: prevExpanded,
            rows: preExpandedRows,
        });
    }, [drawer, onDrawerClose, expanded, prevExpanded, preExpandedRows]);
    if (drawer && !multipleDrawersOpen) {
        var rowToExpand = getRowToExpand(expanded, prevExpanded);
        if (rowToExpand) {
            toggleAllRowsExpanded(false);
            toggleRowExpanded([rowToExpand]);
        }
    }
    if (isLgUp || suppressMdDownLayout) {
        return (React.createElement(LgUpTable, __assign({}, __assign({ tableInstance: tableInstance, drawer: drawer, withRowHeadings: withRowHeadings, rowClickHandler: rowClickHandler, selectRow: selectRow, fullWidth: fullWidth, withFooter: withFooter, ref: ref }, sharedProps))));
    }
    return (React.createElement(TableCardList, __assign({}, __assign({ tableInstance: tableInstance, drawer: drawer, showFromMdDown: showFromMdDown, mdDownHeaderDetail: mdDownHeaderDetail, mdDownDrawerName: mdDownDrawerName, mdDownColumnFullWidth: mdDownColumnFullWidth, ref: ref }, sharedProps))));
};
// You cannot easily pass generics to forwardRefs, hence the casting here
// (https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref)
var Table = React.forwardRef(TableRefForwarding);
export { Table };
//# sourceMappingURL=Table.js.map